import styled from 'styled-components';
import CTA from '../../atoms/CTA';
import { CTAIconPosition } from '../../atoms/CTA/CTA.constants';
import { Headline500Skin } from '../../atoms/Headline/HeadlineSkins';
import { Copytext } from '../../atoms/Copytext';
import { ONE_TRUST_COOKIES_CATEGORIES } from '~/providers/CookieShield/CookieShield.helpers';
import CookieShield from '~/providers/CookieShield';

const StyledText = styled(Copytext)`
  h1,
  h2,
  h3,
  h4 {
    ${Headline500Skin};
    margin-bottom: 15px;
  }

  p {
    margin-top: 0;
  }

  p + p {
    margin-top: 15px;
  }
`;

const StyledCta = styled(CTA)`
  margin-top: 15px;
`;

const ImageWrapper = styled.div`
  width: 100%;
  margin-top: 25px;
  img {
    max-width: 230px;
  }
`;

/**
 * ExternalReviews component.
 * @param {ExternalReviewsTypes} props - The properties for the component.
 * @returns {React.ReactElement} The rendered component.
 */

const ExternalReviews = ({ text, image, externalImage, link }) => {
  const hasText = !!text && text !== '';
  const hasLink = !!link?.href && !!link?.text;
  const hasImage = !!image?.url;
  const hasExternalImage = !!externalImage?.url;

  return (
    <CookieShield category={ONE_TRUST_COOKIES_CATEGORIES.THIRD_PARTY}>
      <div>
        {hasText && <StyledText richtext={text} />}
        {hasImage && (
          <ImageWrapper>
            <img src={image?.url} title={image?.title} alt={image?.alt} />
          </ImageWrapper>
        )}
        {hasExternalImage && (
          <ImageWrapper>
            <img
              src={externalImage?.url}
              title={externalImage?.title}
              alt={externalImage?.alt}
            />
          </ImageWrapper>
        )}
        {hasLink && (
          <StyledCta
            skin="TERTIARY"
            {...link}
            icon="ARROW_ANIMATION"
            iconPos={CTAIconPosition.Before}
          />
        )}
      </div>
    </CookieShield>
  );
};

export default ExternalReviews;
